import reusables from '@styles/theme/reusables';
export default {
  checkboxWrapper: {
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'column'
  },
  checkboxContainer: {
    display: 'inline-flex',
    alignItems: 'center'
  },
  hiddenCheckbox: {
    display: 'none'
  },
  error: (showError: boolean) => ({
    width: '100%',
    color: 'accent700',
    fontFamily: 'uniform',
    fontWeight: 'normal',
    fontSize: 'caption',
    height: showError ? '25px' : 0,
    opacity: showError ? 1 : 0,
    visibility: showError ? 'visible' : 'hidden',
    ...reusables.mainTransition('opacity')
  }),
  checkMarkContainer: (isChecked: boolean, showError: boolean, disabled = false) => {
    const borderColor = isChecked ? 'darkGrey700' : 'lightGrey700';
    const opacity = disabled ? '0.6 ' : '1';
    return {
      borderWidth: '1px',
      borderStyle: 'solid',
      mr: '8px',
      borderColor: showError ? 'accent700' : borderColor,
      width: '18px',
      height: '18px',
      display: 'inline-flex',
      background: isChecked ? 'darkGrey700' : 'transparent',
      opacity,
      '&:focus': {
        // outline: '2px solid blue500',
        // outlineOffset: '2px',
      }
    };
  },
  checkMarkIcon: (isChecked: boolean, isReadonly?: boolean, disabled = false) => {
    let opacity = isChecked ? '1' : '0';
    if (disabled) opacity = '0.6';
    return {
      opacity,
      cursor: isReadonly || disabled ? 'default' : 'pointer',
      ...reusables.mainTransition('opacity')
    };
  },
  checkboxLabel: {
    letterSpacing: '0',
    textAlign: 'left',
    cursor: 'pointer'
  }
};